import { DateTime } from 'luxon'
import { QUERY_FIND_BENEFIT_BY_ID_COMMUNICATE_CHANNEL } from '@/modules/campanhas/cupom-desconto/graphql'

export default {
  data() {
    return {
      isLoadingCampaign: false,
    }
  },
  methods: {
    async loadBenefit({ assignFieldsFn }) {
      if (!this.$route.params.benefitId) return

      try {
        this.isLoadingCampaign = true

        const {
          data: { findBenefitById },
        } = await this.$apollo.mutate({
          mutation: QUERY_FIND_BENEFIT_BY_ID_COMMUNICATE_CHANNEL,
          fetchPolicy: 'no-cache',
          variables: {
            id: this.$route.params.benefitId,
            franchise: this.isFranchise,
          },
          context: {
            uri: this.$microservicesUrls['benefitsManager'],
          },
        })

        const today = DateTime.now().startOf('day')
        const startDate = DateTime.fromISO(findBenefitById.startDate, { zone: 'utc' }).startOf('day')
        const endDate = DateTime.fromISO(findBenefitById.expiresAt, { zone: 'utc' }).startOf('day')

        const parsedSendDate = startDate < today ? today.toFormat('yyyy-MM-dd') : startDate.toFormat('yyyy-MM-dd')

        const parsedFinalDate = endDate.toFormat('yyyy-MM-dd')

        assignFieldsFn({
          benefit: findBenefitById,
          parsedSendDate,
          parsedFinalDate,
        })
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      } finally {
        this.isLoadingCampaign = false
      }
    },
  },
}
